import { render, staticRenderFns } from "./QuizContent.vue?vue&type=template&id=cc8f56dc&scoped=true&"
import script from "./QuizContent.vue?vue&type=script&lang=js&"
export * from "./QuizContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8f56dc",
  null
  
)

export default component.exports